/**
 * @generated SignedSource<<32a68cc5880bc429b1f5833125ea5e79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableAsanaInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type disableAsanaMutation$variables = {
  input: DisableAsanaInput;
};
export type disableAsanaMutation$data = {
  readonly disableAsana: {
    readonly viewer: {
      readonly asanaEnabled: boolean | null;
    } | null;
  } | null;
};
export type disableAsanaMutation = {
  variables: disableAsanaMutation$variables;
  response: disableAsanaMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asanaEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableAsanaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableAsanaPayload",
        "kind": "LinkedField",
        "name": "disableAsana",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableAsanaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableAsanaPayload",
        "kind": "LinkedField",
        "name": "disableAsana",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47a5a6c4e25600cb40a128f78a4492db",
    "id": null,
    "metadata": {},
    "name": "disableAsanaMutation",
    "operationKind": "mutation",
    "text": "mutation disableAsanaMutation(\n  $input: DisableAsanaInput!\n) {\n  disableAsana(input: $input) {\n    viewer {\n      asanaEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a097989b51664419395a439e503bc3b5";

export default node;
